let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("7yPxN")).then(() => parcelRequire('2wW2U'));